




// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'LengthHelper',  
  props: {    
    targetLengthMin:{
      type:Number,
      required:true,
      default:250
    },
    targetLengthMax:{
      type:Number,
      required:true,
      default:350
    },
    textLength:{
      type:Number,
      required:true
    }
  }
})
export default class LengthHelper extends Vue {
  targetLengthMin!:number
  targetLengthMax!:number
  textLength!:number
  toleranceLength!:number

  get ok() {
    return this.textLength <= this.targetLengthMax && this.textLength >= this.targetLengthMin
  }
}
